import { createContext } from 'react'

import { PermissionsContextType } from '@permissions/permissions.types'

export const PermissionsContext = createContext<PermissionsContextType>({
  isLoading: true,
  isAllowedTo: () => false,
})
